import { globalVariables } from "helper/globalVariables";
import { useEffect, useRef, useState } from "react";
import SearchBar from "shared/Components/search";
import { TableWithPagination } from "shared/Components/tableWithPagination";
import Layout from "shared/Layout";
import { PaymentMobileCardComponent } from "./components/MobileCardComponent";
import { MobilePagination } from "shared/Components/mobilePagination";
import { useLazyQuery } from "@apollo/client";
import {
  getAllRegisteredDogsByAdminQuery,
  updateRegisteredDogMarkPaidMutation,
} from "redux/features/superAdminSlice/managePaymentSlice/managePaymentGql";
import { client } from "helper/apolloConfig";
import { PopUpMessages } from "shared/Components/popUpMessages";
import { debounce } from "lodash";
import PaymentRowComponent from "./components/PaymentRow";
import Loader from "shared/Components/loader";
import PageInfo from "shared/Components/pageInfo";

const columns = [
  globalVariables.ownerName,
  globalVariables.dogsName,
  globalVariables.email,
  globalVariables.phoneNumber,
  globalVariables.memberSince,
  globalVariables.amount,
  globalVariables.paymentStatus,
];

// Column width ratios: Payment Status reduced by 15%, extra space distributed to Email and Member Since
const columnWidths = ['15%', '14%', '22%', '13%', '16%', '10%', '10%'];

const Payments = () => {
  const [getData, { loading, error, data }] = useLazyQuery(
    getAllRegisteredDogsByAdminQuery,
    { fetchPolicy: "network-only" }
  );
  const resultData = data?.getAllRegisteredDogsByAdmin ?? [];
  const [apiData, setApiData] = useState({
    title: "",
    desc: "",
    type: "pending",
  });
  const modalRef = useRef();
  const searchRef = useRef();

  useEffect(() => {
    handlePaginationData({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePaginationData = ({ page = 1, size = 10, search = "" }) => {
    getData({
      variables: {
        pageNumber: page,
        pageSize: size,
        search,
      },
    });
  };

  const renderTableBody = () => {
    return resultData?.data?.map((item, index) => {
      return (
        <PaymentRowComponent
          // authId={item?.authId}
          key={item?.id}
          data={item}
          index={index}
          onChangeStatus={onChangeStatus}
        />
      );
    });
  };

  const onChangeStatus = async (id, status) => {
    // modalRef.current.openModal();
    try {
      const result = await client.mutate({
        mutation: updateRegisteredDogMarkPaidMutation,
        variables: { authId: id, data: { payment_status: status } },
      });

      if (result?.data?.updateRegisteredDogMarkPaid) {
        modalRef.current.openModal();
        setApiData({
          ...apiData,
          title: globalVariables.success,
          desc: result?.data?.updateRegisteredDogMarkPaid?.message,
          type: "success",
        });
      }
    } catch (error) {
      modalRef.current.openModal();
      setApiData({
        ...apiData,
        title: globalVariables.error,
        desc: error?.message,
        type: "pending",
      });
    }
  };

  const onCloseModal = () => {
    handlePaginationData({ page: resultData?.pageNumber });
    searchRef.current?.onReset();
  };

  const onSearch = (event) => {
    const value = event?.target?.value;
    if (value) {
      handlePaginationData({
        search: value,
        page: resultData?.pageNumber,
      });
    } else {
      handlePaginationData({ page: resultData?.pageNumber });
    }
  };

  const debouncedSearch = debounce(onSearch, 1000);

  const MobileListing = () => {
    return (
      <div className="mt-[20px]">
        <div className="pb-[12px]">
          {resultData?.data?.map((data, index) => (
            <PaymentMobileCardComponent
              data={data}
              key={index.toString()}
              onChangeStatus={(option) => onChangeStatus(data?.id, option)}
            />
          ))}
        </div>
        {resultData?.totalPages > 1 ? (
          <MobilePagination
            currentPage={resultData?.pageNumber}
            totalPages={resultData?.totalPages}
            handlePageChange={(page) => handlePaginationData({ page })}
          />
        ) : (
          <></>
        )}
      </div>
    );
  };

  return (
    <div className={`App lg:rounded-md min-h-screen lg:ml-[17rem] sm:pt-8 bg-white lg:p-10`}>
      <PageInfo title={globalVariables.payments}/>
      <div className={`mt-[20px] md:hidden`}>
        <div className="max-w-md mx-auto max-[470px]:px-5">
          <span className="font-semibold text-gray-900">
            {globalVariables.detailOfMembers}
          </span>
          <div className="mt-2">
            <SearchBar
              width={"w-full"}
              onChange={debouncedSearch}
              placeholder={globalVariables.search}
              ref={searchRef}
            />
          </div>
        </div>
        {loading ? <Loader /> : <MobileListing />}
      </div>
      <div className="hidden md:block md:mt-[16px] lg:block lg:mt-8">
        <TableWithPagination
          headData={columns}
          title={globalVariables.detailOfMembers}
          tableBody={renderTableBody()}
          headerComponent={
            <SearchBar
              onChange={debouncedSearch}
              placeholder={globalVariables.search}
            />
          }
          isHeaderComponentRow={true}
          loading={loading}
          error={error}
          itemsPerPage={10}
          totalPage={resultData?.totalPages}
          handlePageChange={(page) => handlePaginationData({ page })}
          columnWidths={columnWidths}
        />
      </div>
      <PopUpMessages
        title={apiData.title}
        desc={apiData.desc}
        type={apiData.type}
        ref={modalRef}
        onCloseModal={onCloseModal}
      />
    </div>
  );
};
export default Payments;
